module.exports = __webpack_public_path__ + "static/media/pre_cast_del_tra.371aca8b.png";